/**
 * Obtiene el token de autenticación.
 * @returns {string} Token guardado o token por defecto.
 */
 export const getToken = (): string => {
    return (
      localStorage.getItem("_login") ||
      "621f6f54ea7e8e9f195e3185daa7c48aa33075c97d465313fc3d3f8887804f5e"
    );
  };
  